import { replaceTokens } from '@components/Utility/Template.js';
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
}
/**
 * Removes HTML tags from a given string.
 *
 * @param {string} htmlString - The string containing HTML tags.
 * @return {string} - The string with HTML tags removed.
 */
export function stripHTML(htmlString) {
    // Use a regular expression to remove HTML tags
    return htmlString.replace(/<\/?[^>]+(>|$)/g, '').trim();
}
/**
 *
 * @param {string} input The input string to be checked for HTML tags.
 * @return {boolean} Returns true if the input string contains any HTML tags, otherwise returns false.
 */
export function containsHTML(input) {
    const htmlTagRegex = /<\/?[a-z][\s\S]*>/i; // Matches opening or closing HTML tags
    return htmlTagRegex.test(input);
}
export function isHTML(input) {
    // for our purposes we expect html string to always begin and end with a tag,
    // so check first and last characters. if it only has tags in the middle of the text, we don't care that doesn't count
    input = input || '';
    input = input.trim();
    if (!input || input.length < 4) {
        return false;
    }
    return input.substring(0, 1) === '<' && input.substring(input.length - 1, input.length) === '>';
}
export function plaintextToHTML(input, wrapperTag = 'div', opts = {}) {
    const { paragraphTag = 'p', keepSoftBreaks = true, autoLink = false } = opts;
    if (!input)
        return '';
    if (isHTML(input)) {
        return input;
    }
    // Normalize line endings
    const text = input.replace(/\r\n?/g, '\n');
    // Split into blocks on blank lines (one or more empty lines)
    const blocks = text.split(/\n{2,}/);
    const html = [];
    for (const rawBlock of blocks) {
        const block = rawBlock.trim();
        // Horizontal rule if it's a line of --- or ___
        if (/^[-_]{3,}\s*$/.test(block)) {
            html.push('<hr/>');
            continue;
        }
        // Detect code fence (optional – off by default; keep as plain para)
        // if (/^```/.test(block)) { html.push(`<pre>${block.replace(/^```|```$/g, '')}</pre>`); continue; }
        // List detection
        const lines = block.split('\n');
        // const listType = classifyListBlock(lines);
        //
        // if (listType) {
        // 	const tag = listType === 'ol' ? 'ol' : 'ul';
        // 	const items = lines
        // 		.map(line => extractListItemText(line))
        // 		.filter(Boolean)
        // 		.map(li => `<li>${autoLink ? linkify(li!, true) : li}</li>`)
        // 		.join('');
        // 	html.push(`<${tag}>${items}</${tag}>`);
        // 	continue;
        // }
        let inner = keepSoftBreaks ? lines.join('<br/>') : lines.join(' ');
        inner = autoLink ? linkify(inner, true) : inner;
        html.push(paragraphTag ? `<${paragraphTag}>${inner}</${paragraphTag}>` : inner);
    }
    if (!wrapperTag) {
        return html.join('\n');
    }
    return `<${wrapperTag}>${html.join('\n')}</${wrapperTag}>`;
}
// type ListType = 'ul' | 'ol' | null;
//
// // Returns 'ul' for bullet lists, 'ol' for ordered lists, or null
// function classifyListBlock(lines: string[]): ListType {
// 	let bullets = 0, numbers = 0, nonEmpty = 0;
//
// 	for (const line of lines) {
// 		if (!line.trim()) continue;
// 		nonEmpty++;
//
// 		if (isBulletLine(line)) bullets++;
// 		else if (isNumberedLine(line)) numbers++;
// 		else return null; // mixed content -> not a list
// 	}
//
// 	if (nonEmpty === 0) return null;
// 	if (bullets === nonEmpty) return 'ul';
// 	if (numbers === nonEmpty) return 'ol';
// 	return null;
// }
//
// function isBulletLine(line: string): boolean {
// 	// bullets: "•", "-", "*", "–" with optional leading spaces/tabs
// 	return /^\s*(?:[•*\-–])\s+/.test(line);
// }
//
// function isNumberedLine(line: string): boolean {
// 	// 1. Foo | 1) Foo | (1) Foo | a. Foo | A) Foo
// 	return /^\s*(?:\(?[0-9]+|\(?[A-Za-z])[\.\)]\s+/.test(line);
// }
//
// function extractListItemText(line: string): string | null {
// 	// strip bullet/number markers
// 	let m = line.match(/^\s*(?:[•*\-–])\s+(.*)$/);
// 	if (m) return m[1].trim();
//
// 	m = line.match(/^\s*(?:\(?[0-9]+|\(?[A-Za-z])[\.\)]\s+(.*)$/);
// 	if (m) return m[1].trim();
//
// 	// if the line is blank, return null
// 	if (!line.trim()) return null;
//
// 	// Fallback (shouldn't happen if classifyListBlock succeeded)
// 	return line.trim();
// }
function linkify(s, targetBlank) {
    // Very permissive URL matcher for http/https
    return s.replace(/(https?:\/\/[^\s<>"']+)/g, (url) => {
        const target = targetBlank ? ' target="_blank" rel="noopener noreferrer"' : '';
        return `<a href="${url}"${target}>${url}</a>`;
    });
}
// export function plaintextToHTML(input: string, wrapperTag: string = 'p'): string {
// 	if (isHTML(input)) {
// 		return input; // already html
// 	}
//
// 	input = input || '';
// 	// supposed to be similar logic to FNConvertPlainTextToHTML.sql for more consistent results
// 	input = input.replaceAll('\r\n\r\n', '<p>&nbsp;</p>'); // double new lines
// 	// input = input.replaceAll(' ', '&nbsp;'); // space character // this was previously commented out, but for true plain to html we do need spaces too. So not sure why it was commented.
// 	// replace multiple spaces with &nbsp; but not single spaces. replacing all spaces causes word wrap to break in the middle of words because it doesnt work on &nbsp;'s to detect words
// 	input = input.replace(/ {2,}/g, (m) => '&nbsp;'.repeat(m.length - 1) + ' ');
// 	input = input.replaceAll('\t', '    '); // tab character -> 4 spaces
// 	input = input.replaceAll('\r\n', '</p><p>'); // single new lines
// 	input = input.replaceAll('\n', '<br/>'); // single new lines
// 	input = input.replaceAll('\r', '<br/>'); // single new lines
//
// 	if (!wrapperTag) {
// 		return input;
// 	}
//
// 	return `<${wrapperTag}>${input}</${wrapperTag}>`;
// }
export function htmlToPlaintext(input) {
    // keep your preferred line breaks
    const BR = '\n';
    const PARA = '\r\n\r\n';
    let s = input;
    // 1) Line-break tags (any attributes)
    s = s.replace(/<br\b[^>]*\/?>/gi, BR);
    // 2) Empty paragraphs -> paragraph break
    s = s.replace(/<p\b[^>]*>\s*(?:&nbsp;|\u00A0|\s)*<\/p>/gi, PARA);
    // 3) Paragraph boundaries: </p><p ...> -> paragraph break
    s = s.replace(/<\/p>\s*<p\b[^>]*>/gi, PARA);
    // 4) Remaining <p> open/close
    s = s.replace(/<p\b[^>]*>/gi, '');
    s = s.replace(/<\/p>/gi, PARA);
    // 5) Optional: lists and horizontal rule (nice-to-have)
    s = s.replace(/<li\b[^>]*>\s*/gi, '- ');
    s = s.replace(/<\/li>/gi, BR);
    s = s.replace(/<hr\b[^>]*\/?>/gi, `${BR}---${BR}`);
    // 6) Non-breaking spaces
    // four &nbsp; in a row -> tab
    s = s.replace(/(?:&nbsp;|\u00A0){4}/gi, '\t');
    // any remaining &nbsp; -> space
    s = s.replace(/&nbsp;|\u00A0/gi, ' ');
    // 7) Strip remaining tags
    s = stripHTML(s);
    // 8) Decode common HTML entities (add more as needed)
    s = s
        .replace(/&gt;/gi, '>')
        .replace(/&lt;/gi, '<')
        .replace(/&amp;/gi, '&')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/g, "'")
        .replace(/&#32;/g, " ");
    // 9) Normalize line breaks and collapse excessive blank lines
    s = s.replace(/\r\n/g, '\n'); // normalize to \n
    s = s.replace(/\n{3,}/g, '\n\n'); // max 2 in a row
    s = s.replace(/\n/g, '\r\n'); // convert back to CRLF if you want
    return s.trim();
}
// export function htmlToPlaintext(input: string): string {
// 	input= input.replaceAll('<br>', '\n')
// 	input= input.replaceAll('<br/>', '\n')
// 	input= input.replaceAll('<br />', '\n')
// 	input= input.replaceAll('&nbsp;&nbsp;&nbsp;&nbsp;', '\t')
// 	input= input.replaceAll('<p>&nbsp;</p>', '\r\n\r\n')
// 	input= input.replaceAll('</p><p>', '\r\n')
// 	input= input.replaceAll('&nbsp;', ' ')
// 	input = stripHTML(input);
//
// 	input= input.replaceAll('&gt;', '>')
// 	input= input.replaceAll('&lt;', '<')
//
// 	return input;
// }
export function isLikelyWordHtml(html) {
    if (!html)
        return false;
    // Common Word signatures
    const markers = [
        /class="?Mso/i,
        /\bmso-/i,
        /xmlns:o=/i,
        /xmlns:w=/i,
        /<!--\s*\[if\s+mso/i,
        /urn:schemas-microsoft-com:office/i,
        /office:word/i
    ];
    return markers.some(rx => rx.test(html));
}
export function stripHtmlStyling(html, options) {
    const removePresentationalAttrs = options?.removePresentationalAttrs ?? true;
    const dropDangerousTags = options?.sanitize ?? true;
    // Parse in an isolated document (not attached to the page)
    const doc = new DOMParser().parseFromString(html, "text/html");
    if (dropDangerousTags) {
        // Remove nodes that can execute or import code/styles
        doc.querySelectorAll("script, style, noscript, iframe, object, embed, link, meta").forEach(n => n.remove());
    }
    const PRESENTATIONAL_ATTRS = new Set([
        "align", "background", "bgcolor", "border", "cellpadding", "cellspacing", "color", "face",
        "hspace", "vspace", "valign", "width", "height"
    ]);
    // Traverse and clean
    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT);
    let node = walker.currentNode;
    while (node) {
        const el = node;
        // Always remove class & style
        el.removeAttribute("class");
        el.removeAttribute("style");
        // Remove inline event handlers (on*)
        Array.from(el.attributes)
            .filter(a => /^on/i.test(a.name))
            .forEach(a => el.removeAttribute(a.name));
        if (removePresentationalAttrs) {
            Array.from(el.attributes)
                .filter(a => PRESENTATIONAL_ATTRS.has(a.name.toLowerCase()))
                .forEach(a => el.removeAttribute(a.name));
        }
        node = walker.nextNode();
    }
    // Serialize back to string
    return doc.body.innerHTML;
}
/**
 * Sanitizes the input HTML by removing script, iframe, object, embed, and style elements, and dangerous attributes.
 *
 * @param {string} input - The input HTML to be sanitized.
 * @return {string} - The sanitized HTML.
 */
export function sanitizeHTML(input) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');
    // Remove all script, iframe, object, embed, and style elements
    ['script', 'iframe', 'object', 'embed', 'style'].forEach(tag => {
        const elements = doc.querySelectorAll(tag);
        elements.forEach(element => element.remove());
    });
    // Remove dangerous attributes (e.g., onclick, onerror) from all elements
    const elements = doc.body.querySelectorAll('*');
    elements.forEach(element => {
        [...element.attributes].forEach(attr => {
            if (attr.name.startsWith('on')
                || attr.name === 'srcdoc'
                || attr.value.toLowerCase().includes('javascript:')
                || (attr.value.toLowerCase().includes('data:')
                    && !(
                    // allow images to keep base64 image src, but not SVGs
                    element.tagName === 'IMG'
                        && (attr.value.startsWith('data:image/jpeg')
                            || attr.value.startsWith('data:image/png')
                            || attr.value.startsWith('data:image/gif')
                            || attr.value.startsWith('data:image/bmp')
                            || attr.value.startsWith('data:image/avif')
                            || attr.value.startsWith('data:image/webp'))))) {
                element.removeAttribute(attr.name);
            }
        });
    });
    return doc.body.innerHTML;
}
/**
 * Checks if a given string contains only numeric digits (0-9).
 *
 * @param {string} input - The string to check.
 * @return {boolean} - Returns true if the string consists only of digits, otherwise false.
 */
export function containsNumbersOnly(input) {
    return /^\d+$/.test(input);
}
/*
// import DOMPurify from 'dompurify';
npm install dompurify
npm i --save-dev @types/dompurify
export function sanitizeHTML(input: string): string {
    // Configure DOMPurify to remove scripts and event handlers while keeping safe HTML
    return DOMPurify.sanitize(input, {
        SAFE_FOR_TEMPLATES: true,
        // You can customize allowed tags and attributes like this:
        ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'div', 'span', 'h1', 'h2', 'h3', 'ul', 'li', 'br'],
        ALLOWED_ATTR: ['href', 'title', 'style'], // Add more if needed
    });
}*/
export function parseCSV(csvText) {
    const rows = csvText.split('\n').filter(row => row.trim() !== '');
    const headers = rows[0].split(',').map(header => header.trim());
    return rows.slice(1).map(row => {
        const values = row.split(',').map(value => value.trim());
        const record = {};
        headers.forEach((header, index) => {
            record[header] = values[index] || '';
        });
        return record;
    });
}
export function isUrl(filter) {
    return filter.startsWith('/fo') || filter.indexOf('/form') > -1 || filter.indexOf('controller.php?action=') > -1;
}
/**
 * Strip all newline characters from a string.
 * @param input  The string to clean.
 * @returns      The same string with no CR or LF characters.
 */
export function stripNewlines(input) {
    return input.replace(/[\r\n]+/g, ' ');
}
export function sanitizeXmlKey(key) {
    // meant to match our XMLSerializer class
    return key.replace('&', 'amp').replace("'", '').replace(' ', '_').replace('<', '').replace('>', '').replace('/', '').replace(',', '');
}
// ex. 'CAD$20.00' returns '20.00'
// ex. 'USD123.99-' returns '-123.99'
export function sanitizeUnknownNumericFormat(numberString) {
    if (!numberString)
        return '';
    // 1) Normalize whitespace (incl. NBSP) and trim
    let s = numberString.replace(/\u00A0/g, ' ').trim();
    // 2) Detect negativity: leading '-', trailing '-', or parentheses
    let negative = false;
    // parentheses anywhere wrapping first number chunk
    const parenMatch = s.match(/\(([^()]+)\)/);
    if (parenMatch) {
        // If the parenthesized bit actually contains digits, treat as negative
        if (/\d/.test(parenMatch[1])) {
            negative = true;
            s = s.replace(/[()]/g, '');
        }
    }
    // leading or trailing minus
    if (/^\s*-/.test(s) || /-\s*$/.test(s)) {
        negative = true;
        s = s.replace(/^\s*-|-\s*$/g, '');
    }
    // 3) Remove currency markers and codes (Unicode currency + common 3-letter codes)
    // Unicode currency class: \p{Sc}; plus kill standalone currency codes around digits.
    // Use the 'u' flag; if your TS target doesn’t support Unicode sets in your runtime,
    // fall back to an explicit symbol list (see comment below).
    s = s
        .replace(/\p{Sc}/gu, '') // any currency sign (€, $, ¥, etc.)
        .replace(/\b[A-Z]{3}\b/g, '') // USD, CAD, EUR, GBP, etc.
        .replace(/[$€£¥₩₽₹₺₫₣₴₦₪₱₭₲₡₵₸₮₼₤]/g, ''); // fallback for engines w/o \p{Sc}
    // 4) Keep only digits, separators (.,,), spaces, apostrophes, underscores
    // (we’ll decide which one is decimal in step 5)
    s = s.replace(/[^0-9.,\s'_]/g, '');
    // 5) Collapse digit-grouping separators in the integer part, preserve the LAST
    // '.' or ',' as the decimal separator if present; everything else is thousand sep.
    s = s.trim();
    // Remove spaces/apostrophes/underscores between digits (grouping)
    s = s.replace(/(?<=\d)[\s'_]+(?=\d)/g, '');
    // Find last '.' or ',' to treat as decimal separator
    const lastSepIdx = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    let normalized;
    if (lastSepIdx > 0 && lastSepIdx < s.length - 1) {
        // Split into integer and fraction at the last sep
        const intPartRaw = s.slice(0, lastSepIdx);
        const fracPartRaw = s.slice(lastSepIdx + 1);
        // Remove any remaining separators from integer part
        const intPart = intPartRaw.replace(/[.,\s'_]/g, '');
        // Fraction: remove any non-digits (defensive)
        const fracPart = fracPartRaw.replace(/[^0-9]/g, '');
        normalized = intPart.length ? `${intPart}.${fracPart}` : `0.${fracPart}`;
    }
    else {
        // No obvious decimal separator; nuke all separators
        normalized = s.replace(/[.,\s'_]/g, '');
    }
    // 6) Apply negativity if needed
    if (negative && normalized) {
        normalized = `-${normalized}`;
    }
    // 7) Trim leading zeros sensibly (but keep "0.x" as-is)
    // Avoid turning "-0.x" into "-.x"
    normalized = normalized.replace(/^(-?)0+(?=\d)/, '$1');
    // Edge cases: ".", "-", "-.", "", etc. -> return empty to force rejection
    if (!/^-?\d+(\.\d+)?$/.test(normalized))
        return '';
    return normalized;
}
export function replaceCID(html, staticParameters = {
    mailid: ''
}, srcTemplate = '/download/ReceivedAttachmentDownload?_a=download&mailid={{mailid}}&contentid={{contentid}}') {
    if (!html)
        return html;
    const normalizeCid = (raw) => {
        let cid = (raw || '').trim();
        // Strip leading cid:
        if (cid.toLowerCase().startsWith('cid:')) {
            cid = cid.slice(4);
        }
        cid = cid.trim();
        // Strip surrounding angle brackets if present: <image001.png@...>
        if (cid.startsWith('<') && cid.endsWith('>')) {
            cid = cid.slice(1, -1).trim();
        }
        return cid.toLowerCase();
    };
    const buildUrl = (cidRaw) => {
        const cid = normalizeCid(cidRaw);
        return replaceTokens(srcTemplate, {
            contentid: cid,
            cid,
            ...staticParameters
        }, { urlEncode: true });
    };
    // Replace src="cid:..." and src='cid:...'
    html = html.replace(/(\s(?:src)\s*=\s*)(["'])(cid:[^"']+)\2/gi, (_m, prefix, quote, cidVal) => {
        const url = buildUrl(cidVal);
        // Add data-cid if not already present nearby is hard with regex; we won't here.
        return `${prefix}${quote}${url}${quote}`;
    });
    // Replace srcset="cid:... 2x, cid:... 1x"
    html = html.replace(/(\s(?:srcset)\s*=\s*)(["'])([^"']*)\2/gi, (_m, prefix, quote, val) => {
        if (val.toLowerCase().indexOf('cid:') === -1)
            return _m;
        const replaced = val
            .split(',')
            .map((part) => {
            const p = part.trim();
            const m = p.match(/^(cid:[^\s]+)(\s+.+)?$/i);
            if (!m)
                return part.trim();
            return `${buildUrl(m[1])}${m[2] || ''}`;
        })
            .join(', ');
        return `${prefix}${quote}${replaced}${quote}`;
    });
    // Replace url(cid:...) in inline styles or style blocks inside HTML
    // html = html.replace(
    // 	/url\(\s*(['"]?)(cid:[^)'" ]+)\1\s*\)/gi,
    // 	(_full, quote: string, cidUrl: string) => {
    // 		const q = quote || '';
    // 		return `url(${q}${buildUrl(cidUrl)}${q})`;
    // 	}
    // );
    return html;
}
